import React from 'react';
import { getPayRateUploadsListData } from '../../../../reducers';
import { FontIcon } from 'react-toolbox';
import { getLocalDate, getMinLocalDate } from '../../../../utils/dateUtils';

export default (state) => {
  const payRateUploads = getPayRateUploadsListData(state);
  return payRateUploads.map((upload) => {
    const upload_copy = {
      id: upload.id,
      active: upload.active,
      uploadName: (<a href={upload.expiring_download_url}>
        <FontIcon style={{ verticalAlign: 'middle' }} value="insert_drive_file" />
      </a>),
      uploadedBy: upload.user.name,
      uploadedOn: getLocalDate(upload.created_at),
      uploadedOnMobile: getMinLocalDate(upload.created_at),
      statusText: upload.status,
      summary: upload.summary,
    };
    if ('crew_id' in upload) upload_copy.crewId = upload.crew_id;
    return upload_copy;
  });
};



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/installers/payRateUploads.jsx